export type LabelBadgeSize = "md" | "sm";

// Shared by BetaBadge, PremiumBadge and BetaPremiumBadge so the tags keep one geometry.
export const labelBadgeBase =
  "inline-flex shrink-0 items-center rounded-md border leading-none font-semibold whitespace-nowrap";

export const labelBadgeSize: Record<
  LabelBadgeSize,
  { tag: string; segment: string }
> = {
  md: {
    tag: "h-5.5 text-[11px] tracking-[0.02em]",
    segment: "gap-1 pr-2 pl-1.5",
  },
  sm: {
    tag: "h-5 text-[10.5px] tracking-[0.01em]",
    segment: "gap-1 pr-1.75 pl-1.25",
  },
};

export const labelBadgeIcon = "size-2.5";

export const premiumSheen =
  "animate-premium-sheen bg-linear-100 from-42% via-50% to-58% bg-size-[220%_100%] bg-clip-text bg-position-[180%_0] text-transparent motion-reduce:animate-none";

// purple-800 rather than the design's purple-600: the sweep must stay above 4.5:1 on white.
export const premiumSheenQuiet =
  "from-burgundy-800 via-purple-800 to-burgundy-800";
